<div class="main-content">
	<div class="container-fluid">
		<div class="col-md-12">
			<div class="card">
				<div class="card-header card-header-{{color}}-6 d-flex justify-content-between align-items-center">
					<h4 class="card-title mb-0" (click)="back()">
						<i class="material-icons">arrow_left</i>
						Payment run
					</h4>
					<a routerLink="/vendors-pending-payment-runs" class="btn btn-sm btn-light">Pending payment runs</a>
				</div>
				<div class="card-body">
					<div class="payment-run-form">
						<h5 class="section-heading">Posting details</h5>
						<form [formGroup]="paymentForm">
							<div class="row g-3">
								<div class="col-md-3">
									<label class="form-label">Currency</label>
									<select formControlName="currency" class="form-control form-control-sm">
										<option *ngFor="let curr of currencies" [value]="curr.currabrev">{{ curr.currabrev }}</option>
									</select>
								</div>
								<div class="col-md-5">
									<label class="form-label">Bank account</label>
									<select formControlName="bankaccount" class="form-control form-control-sm">
										<option *ngFor="let bank of bankAccounts" [value]="bank.accountcode">{{ bank.bankaccountname }}</option>
									</select>
								</div>
								<div class="col-md-2">
									<label class="form-label">Starting number</label>
									<input type="text" formControlName="checkNumber" class="form-control form-control-sm" (change)="onCheckNumberChange()" placeholder="e.g. 1001" />
									<small class="form-text text-muted">Check # when payment type is Check</small>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="payment-run-field w-100">
										<mat-label>Posting date</mat-label>
										<input matInput formControlName="postingDate" [matDatepicker]="postingDatePicker" />
										<mat-datepicker-toggle matSuffix [for]="postingDatePicker"></mat-datepicker-toggle>
										<mat-datepicker #postingDatePicker></mat-datepicker>
									</mat-form-field>
								</div>
							</div>
						</form>

						<h5 class="section-heading mt-4">Search criteria</h5>
						<div class="row g-3">
							<div class="col-md-4">
								<label class="form-label">From vendor</label>
								<app-vendor-auto-complete (vendor_selected)="onVendorStartSelected($event)"></app-vendor-auto-complete>
							</div>
							<div class="col-md-4">
								<label class="form-label">To vendor</label>
								<app-vendor-auto-complete (vendor_selected)="onVendorEndSelected($event)"></app-vendor-auto-complete>
							</div>
							<div class="col-md-4">
								<label class="form-label">Vendor type</label>
								<select [(ngModel)]="vendorType" class="form-control form-control-sm">
									<option value="">All</option>
									<option *ngFor="let type of vendorTypes" [value]="type.code">{{ type.description }}</option>
								</select>
							</div>
						</div>
						<div class="row g-3">
							<div class="col-md-4">
								<label class="form-label">Include invoices eligible for discount</label>
								<select [(ngModel)]="includeDiscount" class="form-control form-control-sm">
									<option value="0">No</option>
									<option value="1">Yes</option>
								</select>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline" class="payment-run-field w-100">
									<mat-label>Payment due date</mat-label>
									<input matInput [matDatepicker]="dueDatePicker" [value]="parseDate(dueDate)" (dateChange)="onDueDateChange($event.value)" />
									<mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #dueDatePicker></mat-datepicker>
								</mat-form-field>
							</div>
						</div>
						<div class="row g-3 mt-2">
							<div class="col">
								<button type="button" class="btn btn-primary btn-sm" (click)="searchChecks()">
									<i class="fa fa-search"></i> Search
									<span *ngIf="searching" class="ms-2">
										<svg class="spinner" width="14" height="14" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
											<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
									</span>
								</button>
							</div>
						</div>
					</div>



				<ng-container *ngIf="successMessage">
				  <div class="success-message">
					<i class="fa fa-check-circle"></i>
					{{ successMessage }}
					<a *ngIf="savedJournal" routerLink="/vendors-pending-payment-runs" class="ml-2 font-weight-bold">View pending runs</a>
				  </div>
				</ng-container>


				<ng-container *ngIf="checks && checks.length">
					<p class="text-muted small mb-2">
						Approve &amp; post sends journal + postings to the server (same as pending run review).
						<a routerLink="/vendors/payment-remittance">Remittance email settings</a> are under Vendors.
					</p>
					<div class="ml-auto mr-auto d-flex align-items-center flex-wrap gap-2">
						<button
							type="button"
							(click)="openRemittancePreview()"
							class="btn btn-outline-secondary"
							[disabled]="actionInProgress"
							matTooltip="Uses the generated payment run. You can also preview from the floating summary before Generate payment run."
							matTooltipPosition="below"
						>
							<i class="fa fa-envelope-o"></i> Preview remittance emails
						</button>
						<button (click)="printCheck()" class="btn btn-danger" [disabled]="actionInProgress">
							<i class="fa fa-file-pdf-o"></i> PDF
						</button>
						<button (click)="finalizePostings()" class="btn btn-success" [disabled]="actionInProgress">
							<i class="fa fa-check-circle"></i> Approve & post
						</button>
						<span *ngIf="actionInProgress" class="d-inline-flex align-items-center">
							<span class="spinner-border spinner-border-sm text-secondary me-1" role="status" aria-hidden="true"></span>
							<span>Posting…</span>
						</span>
					</div>

					<!-- Check Cards -->
					<div class="container">
						<div *ngFor="let check of checks | keyvalue" class="ap-clerk-check-card">
							<div class="ap-clerk-check-card__header">
								<h4>{{ check.value.check.payorder }}</h4>
							</div>

							<div class="ap-clerk-check-card__details">
								<div class="ap-clerk-check-detail">
									<label>Pay Order:</label>
									<span class="ap-clerk-check-value">{{ check.value.check.payorder }}</span>
								</div>
								<div class="ap-clerk-check-detail">
									<label>Amount:</label>
									<span class="ap-clerk-check-value">${{ check.value.check.amount | number: '1.2-2' }}</span>
								</div>
								<div class="ap-clerk-check-detail">
									<label>Date:</label>
									<span class="ap-clerk-check-value">{{ check.value.check.date }}</span>
								</div>
								<div class="ap-clerk-check-detail">
									<label>Pay Word:</label>
									<span class="ap-clerk-check-value">{{ check.value.check.payword }}</span>
								</div>
								<div class="ap-clerk-check-detail">
									<label>Address:</label>
									<span class="ap-clerk-check-value">{{ check.value.check.addr }}</span>
								</div>
							</div>

							<div class="ap-clerk-check-card__footer">
								<div class="ap-clerk-check-summary">
									Total Amount Paid: <span>${{ check.value.postings.AccumBalance | number: '1.2-2' }}</span>
								</div>
								<div class="ap-clerk-check-summary">
									Currency: <span>{{ check.value.postings.Currency }}</span>
								</div>
							</div>
						</div>
					</div>
				</ng-container>

				<ng-container>
					<div *ngIf="data && data.success" class="vendor-container">
						<div class="transaction-header">
							<div class="transaction-checkbox">
								<label class="mb-0">Select all&nbsp;&nbsp;</label>
								<label class="group-select-all">
									<input type="checkbox" class="group-select-all-input" [checked]="allVendorsSelected()" (change)="setAllVendorsSelection($any($event.target).checked)">
									<span class="group-select-all-checkmark"></span>
								</label>
							</div>
							<div class="transaction-details mt-2">Transaction Details</div>
							<div class="transaction-dates mt-2">Dates</div>
							<div class="transaction-amounts">Amounts</div>
							<div class="transaction-discount">Discount</div>
							<div class="transaction-amount-due">Amount Due</div>
						</div>


					<div *ngFor="let vendor of checklist | keyvalue" class="vendor-group card-header mt-0 mb-0">
						<div class="row mt-0 mb-0 align-items-end">
							<!-- Vendor Name -->
							<div class="col-4 text-left">
								<label class="mb-0">Vendor</label>
								<h4 class="mb-0">
									<b>{{ vendor.key }} {{ vendor.value[0]?.suppname }}</b>
								</h4>
							</div>
							<div class="col-1 text-center group-select-all-cell">
								<label class="mb-0">Select all</label>
								<label class="group-select-all">
									<input type="checkbox" class="group-select-all-input" [attr.data-supplier]="vendor.key" [(ngModel)]="vendorChecks[vendor.key]" (change)="updateGroupCheck(vendor.key)" />
									<span class="group-select-all-checkmark"></span>
								</label>
							</div>
							<div class="col-3 text-center">
								<label class="mb-0">Payment date</label>
								<mat-form-field appearance="outline" class="check-date-field">
									<input matInput [matDatepicker]="vendorCheckDatePicker" [value]="parseDate(vendorDates[vendor.key])" (dateChange)="onVendorCheckDateChange(vendor.key, $event.value)" />
									<mat-datepicker-toggle matSuffix [for]="vendorCheckDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #vendorCheckDatePicker></mat-datepicker>
								</mat-form-field>
							</div>
							<div class="col-3 text-center">
								<label class="mb-0">Ref #</label>
								<input type="text" class="form-control text-center" [(ngModel)]="vendorCheckNumbers[vendor.key]" />
							</div>
							<div class="col-1 text-center">
								<label class="mb-0">&nbsp;</label>
								<button class="btn btn-danger btn-sm removecheck d-block" (click)="removeVendor(vendor.key)">
									<i class="fa fa-minus"></i>
								</button>
							</div>
						</div>
						<div class="row mt-1 mb-2 vendor-payment-type-row">
							<div class="col-12">
								<label class="vendor-payment-type-row__label">Payment type</label>
								<div class="vendor-payment-type" role="group" aria-label="Payment type">
									<button type="button" class="vendor-payment-type__option" *ngFor="let method of paymentMethods" [class.vendor-payment-type__option--selected]="vendorPaymentTypes[vendor.key] === method.paymentname" (click)="vendorPaymentTypes[vendor.key] = method.paymentname">
										{{ method.paymentname }}
									</button>
								</div>
							</div>
						</div>

							<div *ngFor="let transaction of vendor.value" class="transaction-row" [ngClass]="{
							'due-soon': isDueSoon(transaction.duedate),
							'discount-available': transaction.discountavail > 0,
							'completed': transaction.bal <= 0
							}">
								<div class="transaction-checkbox">
									<label class="custom-checkbox">
										<input type="checkbox" [id]="'check-' + transaction.id" [(ngModel)]="transaction.selected" (change)="updateVendorTotal(vendor.key)" />
										<span class="checkmark"></span>
									</label>
								</div>

								<div class="transaction-details">
									<label class="transaction-type">
										{{ transaction.typename }}
										<small>({{ transaction.transno }})</small>
									</label>
									<br />
									<b class="transaction-reference">{{ transaction.suppreference }}</b>
								</div>
								<div class="transaction-dates">
									<label class="transaction-dates-label">Inv Date | Due Date</label>
									<br />
									<span class="transaction-dates-values">
										{{ transaction.trandate }} | {{ transaction.duedate }}
									</span>
								</div>
								<div class="transaction-amounts">
									<div class="amount-item" [ngClass]="{'positive-amount': transaction.ovamount + transaction.ovgst > 0, 'negative-amount': transaction.ovamount + transaction.ovgst < 0}">
										<label class="amount-label">Net:</label>
										<span class="amount-value">${{ transaction.ovamount + transaction.ovgst | number: '1.2-2' }}</span>
									</div>
									<div class="amount-item" [ngClass]="{'positive-amount': transaction.alloc > 0, 'negative-amount': transaction.alloc < 0}">
										<label class="amount-label">Applied:</label>
										<span class="amount-value">${{ transaction.alloc | number: '1.2-2' }}</span>
									</div>
								</div>


								<div class="transaction-discount">
									<label class="transaction-discount-label" [ngClass]="{
									'due-soon': isDueSoon(transaction.discdate),
									'discount-available': transaction.discountavail > 0 }">
										Discount:
										<small class="transaction-discount-date">{{ transaction.discdate }}</small>
									</label>
									<div class="discount-wrapper">
										<input class="transaction-discount-input" type="text" [(ngModel)]="transaction.disc" (ngModelChange)="updateVendorTotal(vendor.key)" />
									</div>
								</div>

								<div class="transaction-amount-due">
									<label class="transaction-label">Amount Due:</label>
									<div class="amount-due-wrapper">
										<span class="currency-indicator">$</span>
										<input class="transaction-due-input" type="text" [(ngModel)]="transaction.bal" (ngModelChange)="updateVendorTotal(vendor.key)" />
									</div>
								</div>


							</div>
							<div class="vendor-total">
								<h5>Total for {{ vendor.key }}: ${{ vendorTotals[vendor.key] | number: '1.2-2' }}</h5>
							</div>
						</div>

						<div class="payment-summary-floater">
							<div class="payment-summary-floater__card">
								<div class="payment-summary-floater__header" (click)="toggleSummary()">
									<span class="payment-summary-floater__title">Total: ${{ totalDue | number: '1.2-2' }}</span>
									<button class="payment-summary-floater__toggle" type="button" (click)="toggleSummary(); $event.stopPropagation()" [attr.aria-label]="summaryCollapsed ? 'Show details' : 'Hide details'">
										<mat-icon>{{ summaryCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
									</button>
								</div>
								<div class="payment-summary-floater__body" *ngIf="!summaryCollapsed">
									<div class="payment-summary-floater__row">
										<span class="payment-summary-floater__label">Discounts</span>
										<span class="payment-summary-floater__value">${{ totalDiscount | number: '1.2-2' }}</span>
									</div>
									<div class="payment-summary-floater__row">
										<span class="payment-summary-floater__label">Transactions</span>
										<span class="payment-summary-floater__value">{{ selectedTransactions }}</span>
									</div>
									<div class="payment-summary-floater__actions">
										<button
											type="button"
											class="btn btn-outline-secondary btn-sm w-100 mb-2"
											(click)="openRemittancePreview()"
											[disabled]="selectedTransactions === 0 || actionInProgress"
											matTooltip="No save or print required — uses selected lines (bal + discount). After Generate payment run, uses that run instead."
											matTooltipPosition="left"
										>
											<i class="fa fa-envelope-o"></i> Preview remittance emails
										</button>
										<button type="button" class="btn btn-danger btn-sm w-100 mb-2" (click)="exportChecklistPdf()" [disabled]="!checklist || actionInProgress || exportingChecklistPdf">
											<mat-spinner *ngIf="exportingChecklistPdf" diameter="18" class="d-inline-block vertical-align-middle me-1"></mat-spinner>
											<i *ngIf="!exportingChecklistPdf" class="fa fa-file-pdf-o"></i> {{ exportingChecklistPdf ? 'Exporting…' : 'Export PDF' }}
										</button>
										<button type="button" class="btn btn-success btn-sm w-100 mb-2" (click)="exportChecklistXls()" [disabled]="!checklist || actionInProgress || exportingChecklistXls">
											<mat-spinner *ngIf="exportingChecklistXls" diameter="18" class="d-inline-block vertical-align-middle me-1"></mat-spinner>
											<i *ngIf="!exportingChecklistXls" class="fa fa-file-excel-o"></i> {{ exportingChecklistXls ? 'Exporting…' : 'Export XLS' }}
										</button>
										<button type="button" class="btn btn-success btn-sm w-100 mb-2" (click)="saveForReview()" [disabled]="selectedTransactions === 0 || actionInProgress">
											<i class="fa fa-save"></i> Save for review
										</button>
										<button type="button" class="btn btn-primary btn-sm w-100 mb-2" (click)="createPrint()" [disabled]="actionInProgress">Generate payment run</button>
										<button *ngIf="loadedJournal != null" type="button" class="btn btn-success btn-sm w-100" (click)="finalizePostings()" [disabled]="selectedTransactions === 0 || actionInProgress">
											<i class="fa fa-check-circle"></i> Approve & post
										</button>
										<div *ngIf="actionInProgress" class="text-center py-2">
											<span class="spinner-border spinner-border-sm text-secondary me-1" role="status"></span>
											<span class="small">Processing…</span>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<ng-template #noResults>
						<div class="alert alert-danger text-center">No Results</div>
					</ng-template>
				</ng-container>
			</div>
		</div>
	</div>
</div>